export const DASHBOARD_STATS_INFO = {
  fixed: {
    budget_vs_archieved: { info: "Achieved Margin as a percentage of Budget Margin. 100% = meets budget; >100% = above budget; <100% = below budget. " },
    accrued_net_margin: { info: "Shows the margin earned based on the work completed till date." },
    billable_revenue: { info: "Revenue from work that is ready to be billed to the client till date." },
    billed_revenue: { info: "Revenue that has already been billed to the client." },
    remaining_budget: { info: "Budget amount remaining for the job." },
    inventory: { info: "Value of delivered work that has not yet been billed to the client." },
    prepaid: { info: "Revenue received in advance for work that has not yet been delivered." },
    backlog: { info: "Shows the revenue allocated to the work that is yet to be billed to the client." },
    spent_vs_consumed: { info: "Shows spent hours compared to consumed hours. Spent is based on logged hours and the consumption factor; consumed is based on approved hours and the consumption factor." },
    allocated_hours: { info: "Shows total allocated hours of a contract" },
  },

  hourly: {
    budget_vs_archieved: { info: "Achieved Margin as a percentage of Budget Margin. 100% = meets budget; >100% = above budget; <100% = below budget. " },
    billable_revenue: { info: "Revenue from work that is ready to be billed to the client till date." },
    billed_revenue: { info: "Revenue that has already been billed to the client." },
    remaining_budget: { info: "Budget amount remaining for the job." },
    inventory: { info: "Revenue of delivered work that has not yet been billed to the client." },
    prepaid: { info: "Revenue received in advance for work that has not yet been delivered." },
    backlog: { info: "Shows the revenue allocated to the work that is yet to be billed to the client." },
    approved_vs_logged: { info: "Shows comparision between Approved hours against Logged hours." },
  },

  dedicated: {
    budget_vs_archieved: { info: "Achieved Margin as a percentage of Budget Margin. 100% = meets budget; >100% = above budget; <100% = below budget. " },
    active_billable_amount: { info: "Value of billables created for the jobs for the current billable period." },
    active_billable_net_cost: { info: "Cost of the work included for the current billable period." },
    billable_revenue: { info: "Revenue from work that is ready to be billed to the client till date." },
    billed_revenue: { info: "Revenue that has already been billed to the client." },
    remaining_budget: { info: "Shows the budget remaining for the job after deducting the net cost." },
    prepaid: { info: "Revenue received in advance for work that has not yet been delivered." },
    inventory: { info: "Value of delivered work that has not yet been billed to the client." },
    backlog: { info: "Shows the revenue allocated to the work that is yet to be billed to the client." },
    spent_vs_consumed: { info: "Shows spent hours compared to consumed hours. Spent is based on logged hours and the consumption factor; consumed is based on approved hours and the consumption factor." },
  },

  bucket: {
    budget_vs_archieved: { info: "Achieved Margin as a percentage of Budget Margin. 100% = meets budget; >100% = above budget; <100% = below budget. " },
    bucket_value: { info: "Total value of the hours purchased upfront by the client." },
    billable_revenue: { info: "Revenue from work that is ready to be billed to the client till date." },
    billed_revenue: { info: "Revenue that has already been billed to the client." },
    remaining_budget: { info: "Budget amount remaining for the job." },
    inventory: { info: "Value of delivered work that has not yet been billed to the client." },
    prepaid: { info: "Revenue received in advance for work that has not yet been delivered." },
    backlog: { info: "Value of work that is yet to be delivered or billed." },
    approved_vs_logged: { info: "Shows Logged hours vs Approved hours." },
  },

  recurring: {
    budget_vs_archieved: { info: "Achieved Margin as a percentage of Budget Margin. 100% = meets budget; >100% = above budget; <100% = below budget. " },
    active_billable_amount: { info: "Value of billables created for the jobs for the current billable period." },
    active_billable_net_cost: { info: "Cost of the work included for the current billable period." },
    billable_revenue: { info: "Revenue from work that is ready to be billed to the client till date." },
    billed_revenue: { info: "Revenue that has already been billed to the client." },
    remaining_budget: { info: "Shows the budget remaining for the job after deducting the net cost." },
    prepaid: { info: "Revenue received in advance for work that has not yet been delivered." },
    inventory: { info: "Value of delivered work that has not yet been billed to the client." },
    backlog: { info: "Shows the revenue allocated to the work that is yet to be billed to the client." },
    approved_vs_logged: { info: "Shows Logged hours vs Approved hours." },
  },
};
